import Component from './Component';
import Fragment from './Fragment';
import View from './View';
import Layout from './Layout';
export {Component, Fragment, View, Layout};

exports.loadComponents = function(helper, getComponent) {
    $('[data-component]').forEach(($container) => {
        var componentName = $container.getAttribute('data-component');
        var Component = getComponent(componentName);
        if (!Component) {
            throw new Error('Component not found: ' + componentName);
        }
        var component = new Component(helper, $container);
        if (component.resolveDependencies) {
            component.resolveDependencies();
        }
        var properties = $container.getAttribute('data-component-properties');
        properties = properties && JSON.parse(properties);
        component.properties = properties || {};
        component.init(component.properties);
        component._loadElements();
        component.load(component.properties);
        component.prepare();
        $container._component = component;
    });
};

exports.loadViews = function(helper, getView) {
    var views = {};
    $('[data-view]').forEach(($view) => {
        var viewName = $view.getAttribute('data-view');
        var View = getView(viewName);
        if (!View) {
            throw new Error('View not found: ' + viewName);
        }
        var view = new View(helper, $view);
        if (view.resolveDependencies) {
            view.resolveDependencies();
        }
        var properties = $view.getAttribute('data-view-properties');
        properties = properties && JSON.parse(properties);
        view.init(properties);
        view._loadElements();
        view.load(properties);
        $view._view = view;
        views[viewName] = view;
    }).forEach(($view) => {
        var parent = $view.getAttribute('data-view-parent');
        if (parent) {
            $view._view._parent = views[parent];
            views[parent]._child = $view._view;
        }
    });
    return views;
};

exports.renderFragment = function renderFragment(helper, getFragment, fragmentName, data) {
    var Fragment = getFragment(fragmentName);
    if (!Fragment) {
        throw new Error('Fragment not found: ' + fragmentName);
    }
    if (!Fragment.prototype.render) {
        var fragmentFn = Fragment;
        return fragmentFn(helper, data);
    }
    var fragment = new Fragment(helper);
    if (fragment.resolveDependencies) {
        fragment.resolveDependencies();
    }
    fragment.render(data);
    if (fragment.parent) {
        return renderFragment(helper, getFragment, fragment.parent, {
            title: fragment.title,
            content: fragment.$container,
        });
    }
    return fragment;
};

exports.renderComponent = function renderComponent(helper, getComponent, componentName, data, properties) {
    var Component = getComponent(componentName);
    var component = new Component(helper, data.$container);
    if (component.resolveDependencies) {
        component.resolveDependencies();
    }
    delete data.$container;
    component.properties = properties || {};
    component.init(component.properties);
    component._initElements();
    component.firstRender();
    var renderResult = component.render(data);
    if (renderResult instanceof Promise) {
        return renderResult.then(() => {
            component.prepare();
            return component;
        });
    }
    component.prepare();
    return component;
};

exports.renderView = function renderView(helper, getView, viewName, data, properties) {
    console.log('render view ' + viewName);
    var View = getView(viewName);
    var view = new View(helper);

    if (view.resolveDependencies) {
        view.resolveDependencies();
    }
    view.init(properties);
    view._initElements();

    return Promise.resolve(view.render(data)).then(() => {
        if (!view.parent) {
            throw new Error('Cannot render a view without a parent: ' + viewName);
        }
        var $parentView = $.first('[data-view="' + view.parent + '"]');

        if ($parentView) {
            $parentView._view.update(view);
            view._parent = $parentView._view;
            return view;
        }

        return renderView(helper, getView, view.parent, {
            title: view.title,
            content: view.$fragment
        }).then((parent) => {
            view._parent = parent;
            return view;
        });
    });
};
